import React from 'react';
import { ExternalLink } from 'lucide-react';
import { projects } from '../data';

const Projects = () => {
  return (
    <section className="px-4 py-20">
      <div className="mx-auto max-w-6xl">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.4em] text-slate-400">Projects</p>
          <h2 className="mt-3 text-4xl font-bold text-white">All builds and experiments in one place.</h2>
          <p className="mt-4 text-base text-slate-300">
            From AI-driven interfaces to developer tooling, here’s a snapshot of the projects I ship and maintain.
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          {projects.map((project) => (
            <a
              key={project.title}
              className="group block rounded-2xl border border-white/10 bg-white/5 p-6 transition hover:border-brand/60 hover:bg-white/10"
              href={project.link}
              target="_blank"
              rel="noreferrer"
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h3 className="mt-2 text-2xl font-semibold text-white">{project.title}</h3>
                </div>
                <ExternalLink className="text-slate-400 transition group-hover:text-white" size={18} />
              </div>
              <p className="mt-4 text-sm text-slate-300">{project.description}</p>
              <div className="mt-5 flex flex-wrap gap-2">
                {project.tech.map((tech) => (
                  <span key={tech} className="rounded-full border border-white/10 px-3 py-1 text-xs text-slate-200">
                    {tech}
                  </span>
                ))}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
